import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children, onSearch }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [searchQuery, setSearchQuery] = useState(queryParams.get('query') || '');

    // Update searchQuery when the URL changes
    useEffect(() => {
        setSearchQuery(queryParams.get('query') || '');
    }, [location.search]);

    return (
        <div className="flex flex-col min-h-screen">
            {/* Sticky Header */}
            <Header
                onSearch={onSearch}
                searchQuery={searchQuery} // Pass the current search query to Header
            />
            {/* Main Content */}
            <main className="flex-1 max-w-7xl mx-auto px-4 py-6 w-full">
                {children}
            </main>
            {/* Sticky Footer */}
            <Footer />
        </div>
    );
};

export default Layout;